import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import axios from 'axios';

import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../../components/button/MasterButton";

import { CloseOrCancelIcon } from "../../../assets/CloseOrCancel";

import  EditButton from "../../../assets/EditButton.svg";
import  RightArrow from "../../../assets/RightArrow.svg";
import  Link from "../../../assets/link.svg";

import "./dashboardSelectStudiesModal.css";

import Skeleton from "../../../components/skeleton/Skeleton";

import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../context/store';

import { updateStudyInfo } from '../../../context/studyInfoSlice';

import { useSharedState } from '../../../context/sharedState';

export type DashboardSelectStudiesModalProps = {
    onCloseClicked: () => void;
    onSendData: (data: string) => void;
};

// Type for grouped studies
interface GroupedStudies {
    [organizationName: string]: { name: string; study_id: number }[];
}

type StudyInfo = {
    StudyOrg: string;
    StudyName: string;
};

const DashboardSelectStudiesModal: React.FC<DashboardSelectStudiesModalProps> = ({ onCloseClicked, onSendData }) => {

    const [loading, setLoading] = useState<boolean>(true);

    let storeStudyMap = useSelector((state: RootState) => state.studyMapping);

    // State to hold grouped studies
    const [groupedStudies, setGroupedStudies] = useState<GroupedStudies>({});
    const [selectedStudyId, setSelectedStudyId] = useState<string | null>(null);
    const [selectedTimeline, setSelectedTimeline] = useState<string | null>("1 Week");
    const [canProceed, setProceedStatus] = useState<boolean>(true);

    const dispatch = useDispatch();

    const { isMobile } = useSharedState();

    useEffect(() => {
        
        console.log("HELLO coming from popup: ", storeStudyMap)

        if(storeStudyMap){

            // Group studies by organization
            const newGroupedStudies: GroupedStudies = {};

            Object.entries(storeStudyMap.studyMapping).forEach(([studyName, details]) => {
                const { organization_name, study_id } = details;
                if (!newGroupedStudies[organization_name]) {
                    newGroupedStudies[organization_name] = [];
                }
                newGroupedStudies[organization_name].push({ name: studyName, study_id });
            });

            // Update state with new grouped studies
            setGroupedStudies(newGroupedStudies);
            

            if(!(Object.keys(newGroupedStudies).length === 0)){
                setLoading(false);
            }


        }

    }, [storeStudyMap])

    // Handle radio button change
    const handleStudyChange = (studyId: string) => {
        setSelectedStudyId(studyId);
    };

    const handleTimelineChange = (timeline: string) => {
        setSelectedTimeline(timeline);
    };

    useEffect(() => {

        if(selectedStudyId && selectedTimeline){
            setProceedStatus(false);
        }

    }, [selectedStudyId, selectedTimeline])


    const changeStudyInStore = () => {

        let newStudy : StudyInfo = {
            StudyOrg: "",
            StudyName: ""
        };

        if(selectedStudyId){

            newStudy = {
                StudyOrg: storeStudyMap.studyMapping[selectedStudyId].organization_name,
                StudyName: selectedStudyId
            }
            
            dispatch(updateStudyInfo(newStudy));
        }

    }

    const sendTimelineToParent = () => {
        if(selectedTimeline){
            onSendData(selectedTimeline); // Send data back to the parent
        }
    };

    return (
       <>
        <div className="dashboard-select-studies-modal">
            <div className="modal-header">
                <div className="main-heading">
                    <span className="title title-medium">Please select a study and timeframe</span>
                </div>  
                <div className="row">
                    
                    <MasterButton
                        options={{
                            layoutType: ButtonLayoutType.Label,
                            size: ButtonSize.Medium,
                            variation: ButtonVariation.Outlined,
                            label: "Proceed",
                            icon:RightArrow,
                            className: "close-button",
                        }}
                        onClick={() => {
                            // Add function to update the studies store here
                            sendTimelineToParent();
                            changeStudyInStore();
                            onCloseClicked();
                          }}
                        disabled={canProceed}
                    />
                    
                </div>      
            </div>

            <div className="studies-and-time-selection-detail">
                <div className="studies-selection-menu">
                    <div className="studies-selection-border">
                        {/* <div className="studies-modal-margin">
                            <span className="title title-medium">Select Study :</span>
                        </div> */}
                        
                        {loading ?
                        <>
                            <div className="loading-center-content">
                                <span className="label label-medium">Loading participant studies...</span>
                            </div>
                        </>
                        
                        :

                        <>
                            {Object.entries(groupedStudies).map(([organizationName, studies]) => (
                                <>
                                    <div key={organizationName} className="studies-wrap">
                                        <div className="label label-medium studies-modal-margin org-margin-top no-hover-effect">{organizationName}</div>
                                        <div>
                                            {studies.map(study => (
                                                <div className="studies-modal-margin">
                                                    <span className="title label-large" key={study.name}>
                                                        <label className="radio-button">
                                                            <input
                                                                type="radio"
                                                                name="study"
                                                                value={study.name}
                                                                checked={selectedStudyId === study.name}
                                                                onChange={() => handleStudyChange(study.name)}
                                                                className={`radio-button-margin ${selectedStudyId === study.name ? 'selected' : ''}`}
                                                            />
                                                            {study.name}
                                                        </label>
                                                    </span>
                                                </div>
                                                
                                            ))}
                                        </div>
                                    </div>
                                
                                </>
                            ))}
                        
                        </>

                        
                        }
                    </div>
                </div>

                {
                    isMobile ? 
                    
                    <></> :
                    
                    <div className="timeline-selection-menu">
                    <div className="studies-selection-border-timeline">

                    {loading ?
                        <>
                            <div className="loading-center-content">
                                <span className="label label-medium">Loading study timelines...</span>
                            </div>
                        </>
                        
                        :

                        <>

                        <div className="studies-modal-margin">
                            <span className="title label-large">
                                <label className="radio-button">
                                    <input
                                        type="radio"
                                        name="timeline"
                                        value="Today"
                                        checked={selectedTimeline === "Today"}
                                        onChange={() => handleTimelineChange("Today")}
                                        className="radio-button-margin"
                                    />
                                    Today
                                </label>
                            </span>
                        </div>
                        <div className="studies-modal-margin">
                            <span className="title label-large">
                                <label className="radio-button">
                                    <input
                                        type="radio"
                                        name="timeline"
                                        value="1 Week"
                                        checked={selectedTimeline === "1 Week"}
                                        onChange={() => handleTimelineChange("1 Week")}
                                        className="radio-button-margin"
                                    />
                                    1 Week
                                </label>
                            </span>
                        </div>
                        <div className="studies-modal-margin">
                            <span className="title label-large">
                                <label className="radio-button">
                                    <input
                                        type="radio"
                                        name="timeline"
                                        value="1 Month"
                                        checked={selectedTimeline === "1 Month"}
                                        onChange={() => handleTimelineChange("1 Month")}
                                        className="radio-button-margin"
                                    />
                                    1 Month
                                </label>
                            </span>
                        </div>
                    </>

                    }

                    </div>
                </div>

                }



                
            </div>
       
        </div>
       </>
    );
};

export default DashboardSelectStudiesModal;


